<template>
  <div>
    <div
      class="modal bounceInDown animated"
      data-backdrop="false"
      role="dialog"
      aria-hidden="true"
      aria-labelledby
      style="display: block; padding-top: 25px;"
      @keyup.esc="close()"
    >
      <div
        class="modal-dialog"
        :style="styles"
        :class="classes"
        :id="isFullScreen"
        fullScreen="fullScreen"
      >
        <div class="modal-content">
          <div class="modal-header text-right">
            <!-- <button type="button" class="close" aria-hidden="true" @click="close()" v-if="closeButton">&times;</button> -->
            <a class="text-muted no-print" href="#" @click.prevent="close()" v-if="closeButton">
              <i class="fa fa-times-circle" style="font-size: 27px;"></i>
            </a>
            <h4 class="modal-title text-left" id>
              <slot class="no-print" name="modal-title"></slot>
            </h4>
          </div>
          <form @submit.prevent="formSubmit()">
            <div class="modal-body" :style="`background: ${background};`">
              <slot name="modal-body"></slot>
            </div>
            <div class="modal-footer" v-if="showFooter">
              <button class="btn btn-default" type="button" @click="close()">Cancelar</button>
              <button class="btn btn-primary" type="submit" :disabled="disableSubmit">
                Salvar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal',
  props: {
    fullScreen: {
      type: Boolean,
      default: false
    },
    classes: {},
    styles: {},
    disableSubmit: {
      type: Boolean
    },
    showFooter: {
      type: Boolean,
      default: false
    },
    background: {
      default: '#FFF',
      type: String
    },
    closeButton: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {}
  },
  created() {
    document.addEventListener('keydown', this.onKeydonEsc)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydonEsc)
  },
  mounted() {
    if (this.$slots['modal-body']) {
      let input = this.$slots['modal-body'][0].elm.querySelector('input:not([disabled])')
      if (input) input.focus()
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },

    formSubmit() {
      this.$emit('form-submit')
    },

    onKeydonEsc(event) {
      if (this.close && event.code === 'Escape') {
        this.close()
      }
    }
  },

  computed: {
    isFullScreen() {
      return !this.fullScreen ? 'normal' : 'fullScreen'
    }
  }
}
</script>

<style lang="css" scoped>
.modal-xl {
  min-width: 99%;
}
.modal-mid-sm {
  min-width: 35%;
}
.modal-md {
  min-width: 50%;
}
.modal-sm {
  min-width: 20%;
  margin-top: 15%;
}
.large {
  min-width: 70%;
}
.modal-large-xl {
  min-width: 80%;
}

#fullScreen {
  width: 100%;
  margin: -30px 0 0 0;
}

#fullScreen > .modal-dialog {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
}

#fullScreen > .modal-content {
  height: auto;
  min-height: 100vh;
  border: 0 none;
  border-radius: 0;
  box-shadow: none;
}

.modal {
  overflow-y: auto;
  background: rgba(0, 0, 0, 0);
  animation: fade-backdrop 0.2s forwards;
}

@keyframes fade-backdrop {
  from {
    opacity: 0;
    background: rgba(0, 0, 0, 0);
  }
  to {
    opacity: 1;
    background: rgba(0, 0, 0, 0.3);
  }
}

@media print {
  button,
  .no-print {
    display: none;
  }
}
</style>
